var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliciesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.938 10.6H2.08973C1.62318 10.6 1.24146 10.96 1.24146 11.4V21.8C1.24146 23.568 2.75986 25 4.63455 25H21.6C23.4747 25 24.9931 23.568 24.9931 21.8V1.8C24.9931 1.36 24.6114 1 24.1448 1H7.17937C6.71282 1 6.3311 1.36 6.3311 1.8V20.2C6.3311 20.848 5.79668 21.8 4.63455 21.8",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5103 5H9.72412V11.4H16.5103V5Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9033 5H21.5999",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9033 8.2002H21.5999",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9033 11.3999H21.5999",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72412 14.6001H21.6",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72412 17.7998H21.6",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72412 21H21.6",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesIcon);
export default __webpack_public_path__ + "static/media/PoliciesIcon.5972add441bb0f4f0518d3691ab54d20.svg";
export { ForwardRef as ReactComponent };